export enum GameResponse {
    GunsOfGlory = 'GunsOfGlory',
    MistyContinent = 'MistyContinent',
    StormShot = 'StormShot'
}